import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6aed587e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Esito")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Chiudi ")
const _hoisted_3 = { class: "cantainer" }
const _hoisted_4 = { class: "top-section" }
const _hoisted_5 = { "text-end": "" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Hai accumulato ")
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "text label" }
const _hoisted_9 = { class: "ion-text-center" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }

import {
  IonContent,
  IonHeader,
  IonToolbar,
  IonTitle,
  modalController,
  IonButtons,
  IonButton,
  IonListHeader,
  IonLabel,
  IonIcon,
  IonItem,
  IonList,
  IonRow,
  IonCol
} from '@ionic/vue';
import {
  checkmarkCircleOutline,
  closeCircleOutline,
  closeOutline,
} from 'ionicons/icons';

import './quiz.scss'


export default /*#__PURE__*/_defineComponent({
  props: {
  quizResult: {
    required: true,
    type: [Array, Object],
  }
},
  setup(__props) {




async function dismissModal() {
  const modal = await modalController
  return modal.dismiss();
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonHeader), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonTitle), null, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }),
            _createVNode(_unref(IonButtons), { slot: "end" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonButton), {
                  size: "large",
                  onClick: dismissModal
                }, {
                  default: _withCtx(() => [
                    _hoisted_2,
                    _createVNode(_unref(IonIcon), {
                      slot: "start",
                      ios: _unref(closeOutline),
                      md: _unref(closeOutline)
                    }, null, 8, ["ios", "md"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(IonContent), { class: "ion-padding" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(IonRow), { class: "row" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonCol), {
                  size: "12",
                  class: "col"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", _hoisted_5, [
                      _hoisted_6,
                      _createElementVNode("img", {
                        src: require('@/assets/imgs/co_icon.png')
                      }, null, 8, _hoisted_7),
                      _createTextVNode(_toDisplayString(__props.quizResult.my_points) + " coins ", 1)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.quizResult.quiz.quiz, (question, index) => {
            return (_openBlock(), _createBlock(_unref(IonList), {
              key: question.id,
              "no-lines": "",
              class: "border-rouded list",
              lines: "none"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonListHeader), null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("p", null, _toDisplayString(question.question), 1)
                    ])
                  ]),
                  _: 2
                }, 1024),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.answers, (answer) => {
                  return (_openBlock(), _createBlock(_unref(IonItem), {
                    key: answer.id,
                    class: "options item"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), null, {
                        default: _withCtx(() => [
                          _createElementVNode("h3", _hoisted_9, _toDisplayString(answer.text), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_unref(IonIcon), {
                        src: answer.correct ? _unref(checkmarkCircleOutline) : _unref(closeCircleOutline),
                        class: _normalizeClass(answer.correct ? 'correct-answer' : 'wrong-answer'),
                        size: "large"
                      }, null, 8, ["src", "class"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128)),
                (JSON.parse(__props.quizResult.my_quiz)[index].answer)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_10, "Hai risposto: " + _toDisplayString(JSON.parse(__props.quizResult.my_quiz)[index].answer.text), 1))
                  : (_openBlock(), _createElementBlock("p", _hoisted_11, "Non hai risposto"))
              ]),
              _: 2
            }, 1024))
          }), 128))
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})